<template>
  <div>
    <v-server-table
      :columns="columns"
      :options="tableOptions"
      @filter="onFilterUpdate"
      id="activeUsersTable"
      ref="activeUsersTable"
      name="activeUsersTable"
    >

    <span slot="date" slot-scope="{row}">
      <span v-if="row.started_at">
        {{ row.started_at | localTime('YYYY-MM-DD') }}
      </span>
    </span>

      <span slot="started_at" slot-scope="{row}">
      <span v-if="row.started_at">
        {{ row.started_at | localTime('HH:mm') }}
      </span>
    </span>

      <span slot="ended_at" slot-scope="{row}">
      <span v-if="row.ended_at">
        {{ row.ended_at | localTime('HH:mm') }}
      </span>
    </span>

      <span slot="ended_at" slot-scope="{row}">
      <span v-if="row.ended_at">
        {{ row.ended_at | localTime('HH:mm') }}
      </span>
    </span>

      <span slot="average_daily_request_time" slot-scope="{row}">
      <span v-if="row.average_daily_request_time">
        {{ getRelativeTimeString(row.average_daily_request_time) }}
      </span>
    </span>

      <span slot="in_break" slot-scope="{row}">
      <va-popover :message="$t('evocall.active_users.in_break')" placement="left" v-if="row.in_break">
        <i class="fa fa-check"></i>
      </va-popover>
    </span>

    </v-server-table>
  </div>
</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin'
import Multiselect from 'vue-multiselect'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import RelativeTimeMixin from '@/mixins/RelativeTimeMixin'

export default {
  components: {
    Multiselect,
    RangeDatePicker
  },
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
    querySearch: {
      type: String,
      required: false,
      default: null
    }
  },
  mixins: [
    TableQueryMixin,
    RelativeTimeMixin
  ],
  data () {
    return {
      columns: [
        'date',
        'started_at',
        'name',
        'nickname',
        'count_daily_requests',
        'average_daily_request_time',
        'in_break'
      ],
      queryUrl: `${this.$store.state.evocall_server}/users`,
      tableOptions: {
        columnsDropdown: false,
        saveState: true,
        filterable: true,
        pagination: {
          show: false,
          chunk: 5,
          nav: 'scroll',
          edge: true
        },
        sortable: ['started_at', 'name', 'nickname', 'count_daily_requests', 'average_daily_request_time', 'in_break'],
        customFilters: ['users', 'start', 'end', 'serviceId'],
        headings: {
          'date': this.$t('evocall.active_users.date'),
          'started_at': this.$t('evocall.active_users.started_at'),
          'name': this.$t('evocall.active_users.name'),
          'nickname': this.$t('evocall.active_users.nickname'),
          'ended_at': this.$t('evocall.active_users.ended_at'),
          'count_daily_requests': this.$t('evocall.active_users.count_daily_requests'),
          'average_daily_request_time': this.$t('evocall.active_users.avg_daily_request_time'),
          'in_break': this.$t('evocall.active_users.in_break')
        },
        columnsClasses: {
          results: 'results',
          actions: 'actions',
          count_daily_requests: 'count_daily_requests',
          average_daily_request_time: 'average_daily_request_time',
          in_break: 'in_break'
        },
        orderBy: {
          column: 'started_at',
          ascending: 1
        }
      }
    }
  },
  mounted () {
    this.emitTableFilter('vue-tables.activeUsersTable.filter::serviceId', this.$store.state[`waiting-room-${this.serviceSlug}`].authClinicalService.id)
  },
  methods: {
    reloadTable: function () {
      this.getTableReference().refresh()
    },
    getTableReference: function () {
      return this.$refs.activeUsersTable
    }
  },
  computed: {
    currentService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evocall_server)
    }
  },
  watch: {
    querySearch: function (search) {
      this.getTableReference().setFilter(search)
    }
  },
  sockets: {
    /**
     * This function is called everytime that an user
     * considered audiologist enters/leaves the plataform
     * so we reload the table to get most recently information
     */
    ONLINE_AUDIOLOGISTS_UPDATED: function () {
      setTimeout(() => {
        this.reloadTable()
      }, 1000)
    },
    /**
     * This function is called everytime that a request is ended
     * so we reload the table to get the most recently information
     * such as the number requests made and average time per request
     */
    QUEUE_ITEM_ENDED: function () {
      setTimeout(() => {
        this.reloadTable()
      }, 1000)
    },
  }
}
</script>
<style lang="scss">

#activeUsersTable {
  td {
    &.count_daily_requests, &.average_daily_request_time, &.in_break {
      text-align: center;
    }
  }
}
</style>
